/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import * as moment from 'moment';
import p from 'vue-strict-prop';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const durationProp = p
    .ofType()
    .validator(d => moment.isDuration(d) && d.isValid()).required;
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const SHOW_INLINE_FEEDBACKS = Object.freeze([
    'all',
    'only-normal',
    'only-peer',
    'none',
]);
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const showInlineFeedbackProp = p.ofStringLiterals(...SHOW_INLINE_FEEDBACKS).default('all');
